// Theme by default loads a jQuery as dependency of the main script.
// Let's include it using ES6 modules import.
import $ from 'jquery'


function calculateForm8(){
  var langszijde = $('.acf-field').find("[data-name='form8_langszijde']").find(':input').val();
  var kopse_kant = $('.acf-field').find("[data-name='form8_kopse_kant']").find(':input').val();
  var hoogte = $('.acf-field').find("[data-name='form8_hoogte']").find(':input').val();

  $.ajax({
    url: '/wp-admin/admin-ajax.php',
    data: {
      action: 'form8Calculate',
      langszijde: langszijde,
      kopse_kant: kopse_kant,
      hoogte: hoogte,
    },
    method: 'POST',
    success: function (html) {
      $('.calculation-result').html(html);
      $('#form8Calc .acf-form-submit input[type="submit"]').prop("disabled", false).addClass('active');
    }
  });
}

$(document).ready(function(){

  $('#form8Calc .acf-form-submit input[type="submit"]').prop("disabled", true);
  $('#form8Calc .acf-form-submit').append('<input type="submit" id="calculate_form8" value="Berekenen" class="calculate-btn btn btn--primary"/>');

  $('#calculate_form8').click(function(e){
    e.preventDefault();
    calculateForm8();
  });

});



// WEBPACK FOOTER //
// ./resources/assets/js/form8.js